;(async () => {
  if (!customElements.get('global-delivery-message')) {
    class GlobalDeliveryMessage extends HTMLElement {
      constructor() {
        super()

        const self = this
        self.countryCodeDefault = 'default'
        self.storageId = 'CODE:session_country_code'

        // Default options
        self.defaultOptions = {
          locationApiUrl: 'https://extreme-ip-lookup.com/json',
          locationFieldName: 'countryCode',
        }

        self.dataOptions = {}

        // Get options from element data and combine with default options
        if (self?.dataset.options) {
          self.dataOptions = JSON.parse(self.dataset.options)
        }

        self.options = {
          ...self.defaultOptions,
          ...self.dataOptions,
        }

        // Initialize
        self.init()
      }

      init() {
        const self = this

        self.deliveryMessageWrapper = document.querySelector('[data-delivery-message-wrapper]')

        // Guard if delivery message wrapper exists on page
        if (!self.deliveryMessageWrapper) {
          return
        }

        // Guard if we already have the country code in the session storage
        if (sessionStorage.getItem(self.storageId) !== null) {
          self.renderDeliveryMessage(sessionStorage.getItem(self.storageId))
          return
        }

        // Fetch the current country code from the API
        fetch(self.options.locationApiUrl)
          .then((response) => response.json())
          .then((data) => {
            // On success send country code to render
            if (data && data[self.options.locationFieldName]) {
              self.renderDeliveryMessage(data[self.options.locationFieldName])
            }

            // Save the new country code in the session storage
            self.setStorage(data[self.options.locationFieldName])
          })
          .catch((e) => {
            console.error(e, 'Global delivery message error - Failed to fetch from location API url.')
            self.renderDeliveryMessage(self.countryCodeDefault)
          })
      }

      // sets storage to item with country code and expiration date
      setStorage(countryCode) {
        const self = this
        sessionStorage.setItem(self.storageId, countryCode)
      }

      // Render handler
      renderDeliveryMessage(countryCode) {
        const self = this
        const messageIdPrefix = '#delivery-message-'

        // If a message block (in the dom) with the given country code is not present change variable to target the default block
        const targetCountryElement = self.querySelector(messageIdPrefix + countryCode)
        if (targetCountryElement) {
          self.deliveryMessageWrapper.innerHTML = ''
          self.deliveryMessageWrapper.appendChild(targetCountryElement)
          targetCountryElement.classList.remove('visually-hidden')
        }
      }
    }

    window.GlobalDeliveryMessage = GlobalDeliveryMessage
    customElements.define('global-delivery-message', GlobalDeliveryMessage)
  }
})()
